import { render, staticRenderFns } from "./ReceivePurchasing.vue?vue&type=template&id=e5d33138&"
import script from "./ReceivePurchasing.vue?vue&type=script&lang=js&"
export * from "./ReceivePurchasing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports